import { ResourceType } from '__types__';
import store from '../../../../store';
import { RESOURCE_TYPES_ACTIONS } from '../../../../store/v1/resource_types/resource_types.constants.js';

export function syncResourceTypeCreatedToRedux(result: ResourceType) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.CREATE_RESOURCE_TYPE_SUCCESS,
    result
  });
}

export function syncResourceTypeUpdatedToRedux(result: ResourceType) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.UPDATE_RESOURCE_TYPE_SUCCESS,
    result
  });
}

export function syncResourceTypeDeletedToRedux(id: number) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.DELETE_RESOURCE_TYPE_SUCCESS,
    id
  });
}

export function syncResourceTypeOrderToRedux(result: ResourceType[]) {
  store.dispatch({
    type: RESOURCE_TYPES_ACTIONS.UPDATE_RESOURCE_TYPE_ORDER_SUCCESS,
    result
  });
}
